import React from 'react';
import { IconCircleCheck, IconDiscount } from 'gatorcomponents';
import * as Styles from './PeriodSelector.styles';

const PeriodSelector = ({
  availableCycles,
  selectedCycle,
  currentProductCycle,
  lastCycle,
  penultimateCycle,
  locale,
  onCycleChange,
}) => {
  const isLastCycleSelected = selectedCycle === lastCycle;
  const showSavingsBanner = availableCycles && availableCycles.length >= 1;

  const getSavingsBannerText = () => {
    const bannerTexts = locale.savingsBannerText || {};
    if (selectedCycle === lastCycle) return bannerTexts.last;
    if (selectedCycle === penultimateCycle) return bannerTexts.penultimate;
    if (selectedCycle === currentProductCycle) return bannerTexts.current;
    return bannerTexts.middle;
  };

  return (
    <Styles.SectionPeriod data-testid="vpsoci-upgrade-listing-period">
      <Styles.SectionPeriodTitle data-testid="vpsoci-upgrade-listing-period-title">
        {locale.title}
      </Styles.SectionPeriodTitle>

      <Styles.PeriodButtonsWrapper data-testid="vpsoci-upgrade-listing-period-buttons">
        {availableCycles && availableCycles.map((cycle) => {
          const isSelected = selectedCycle === cycle;
          const isCurrentCycle = cycle === currentProductCycle;
          const isBestValue = cycle === lastCycle;

          return (
            <Styles.PeriodButtonWrapper key={cycle}>
              {isBestValue && (
                <Styles.BestValueBadge data-testid={`vpsoci-upgrade-listing-period-best-value-${cycle}`}>
                  {locale.bestValueLabel}
                </Styles.BestValueBadge>
              )}
              <Styles.PeriodButton
                onClick={() => onCycleChange(cycle)}
                isSelected={isSelected}
                data-testid={`vpsoci-upgrade-listing-period-button-${cycle}`}
              >
                <Styles.PeriodButtonLabel isSelected={isSelected}>
                  {locale.cycles?.[cycle]}
                </Styles.PeriodButtonLabel>
                {isCurrentCycle && (
                  <Styles.PeriodButtonCurrentLabel isSelected={isSelected} data-testid={`vpsoci-upgrade-listing-period-current-${cycle}`}>
                    {locale.currentCycleLabel}
                  </Styles.PeriodButtonCurrentLabel>
                )}
              </Styles.PeriodButton>
            </Styles.PeriodButtonWrapper>
          );
        })}
      </Styles.PeriodButtonsWrapper>

      {showSavingsBanner && (
        <Styles.SavingsBanner isLast={isLastCycleSelected} data-testid="vpsoci-upgrade-listing-savings-banner">
          {isLastCycleSelected
            ? <IconCircleCheck size="sm2" color="highPure" />
            : <IconDiscount size="sm2" color="highPure" />}
          <Styles.SavingsBannerText isLast={isLastCycleSelected}>
            {getSavingsBannerText()}
          </Styles.SavingsBannerText>
        </Styles.SavingsBanner>
      )}

      <Styles.SectionDivider />
    </Styles.SectionPeriod>
  );
};

export default PeriodSelector;
